import * as React from 'react';

import { useEvent } from 'react-use';

interface UseComposerKeyboardFocusOptions {
  inputRef: React.RefObject<HTMLTextAreaElement | null>;
  isTouchDevice: boolean;
}

export function useComposerKeyboardFocus({
  inputRef,
  isTouchDevice,
}: UseComposerKeyboardFocusOptions): void {
  useEvent('keydown', (e: KeyboardEvent) => {
    if (isTouchDevice) return;

    const input = inputRef.current;
    if (!input || document.activeElement === input) return;

    const activeElement = document.activeElement;
    const isEditable =
      activeElement instanceof HTMLInputElement ||
      activeElement instanceof HTMLTextAreaElement ||
      (activeElement instanceof HTMLElement && activeElement.isContentEditable);
    if (isEditable) return;

    if (e.metaKey || e.ctrlKey || e.altKey) return;

    if (e.key.length === 1) {
      e.preventDefault();
      input.focus();
      const newValue = input.value + e.key;
      input.value = newValue;
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
  });
}
